import { render, staticRenderFns } from "./SplitText.vue?vue&type=template&id=4fa3d6e6"
import script from "./SplitText.vue?vue&type=script&lang=js"
export * from "./SplitText.vue?vue&type=script&lang=js"
import style0 from "./SplitText.vue?vue&type=style&index=0&id=4fa3d6e6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports